import { render, staticRenderFns } from "./TeachersAdd.vue?vue&type=template&id=8c00c87c"
import script from "./TeachersAdd.vue?vue&type=script&lang=js"
export * from "./TeachersAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports